import React, { useState, useEffect } from 'react';
import {
    Autocomplete,
    TextField,
    Grid,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    CircularProgress
} from '@mui/material';
import Swal from 'sweetalert2';
import debounce from 'lodash.debounce';
import { useMemo, useCallback } from 'react';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
const TrasladoPuntos = () => {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [clientes, setClientes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inputValueD, setInputValueD] = useState('');
    const [inputValueA, setInputValueA] = useState('');
    const [clienteDebitar, setClienteDebitar] = useState(null);
    const [clienteAcreditar, setClienteAcreditar] = useState(null);
    const [puntosClienteD, setPuntosClienteD] = useState(0);
    const [lempirasClienteD, setLempirasClienteD] = useState(0);
    const [puntosClienteA, setPuntosClienteA] = useState(0);
    const [lempirasClienteA, setLempirasClienteA] = useState(0);
    const [lempirasAcreditar, setLempirasAcreditar] = useState(0);
    const [concepto, setConcepto] = useState('');
    const [trasladosPuntos, setTrasladosPuntos] = useState([]);
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const [search, setSearch] = useState('');
    const { user } = useUser();
    const [tipoOperacion, setTipoOperacion] = useState('Traslado'); // Nuevo estado

    useEffect(() => {
        const today = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(today.getMonth() - 3);

        // Convertir fechas a formato ISO (YYYY-MM-DD) para los campos de fecha
        setFechaHasta(today.toISOString().split('T')[0]);
        setFechaDesde(threeMonthsAgo.toISOString().split('T')[0]);
    }, []);

    const fetchClientes = async (search = '') => {
        try {
            setIsLoading(true);
            const response = await fetch(`${server}/MgClientes/buscador/${search}`);
            const data = await response.json();
            console.log(data);
            // Asegúrate de que los datos sean un arreglo antes de asignarlos
            if (Array.isArray(data)) {
                setClientes(data);
            } else if (data && data.clientes && Array.isArray(data.clientes.$values)) {
                setClientes(data.clientes.$values); // Ajusta según la estructura real de tu API
            } else {
                setClientes([]);
            }
        } catch (error) {
            console.error('Error al cargar los clientes:', error);
            setClientes([]); // Asegúrate de resetear el estado en caso de error
        } finally {
            setIsLoading(false);
        }
    };


    const fetchPuntosLempirasCA = async (clienteId) => {
        try {
            console.log("Ejecutando fetchPuntosLempirasCA con ID Cliente:", clienteId);
            const response = await fetch(`${server}/MgClientesPuntosCobroes/puntosCliente/${clienteId}`);
            if (response.ok) {
                const data = await response.json();
                console.log("Respuesta obtenida en fetchPuntosLempirasCA:", data);

                // Verificar si la respuesta contiene $values
                const clientePuntos = data?.$values?.[0];
                if (clientePuntos) {
                    setPuntosClienteA((clientePuntos.saldo).toFixed(2) || 0);
                    const lempiras = (clientePuntos.saldo * 0.030).toFixed(2);
                    setLempirasClienteA(lempiras || 0);
                } else {
                    console.error("No se encontraron datos en $values");
                    setPuntosClienteA(0);
                    setLempirasClienteA(0);
                }
            } else {
                console.error("Error en fetchPuntosLempirasCA: Respuesta no OK");
            }
        } catch (error) {
            console.error("Error en fetchPuntosLempirasCA:", error);
        }
    };

    const fetchPuntosLempirasCD = async (clienteId) => {
        try {
            console.log("Ejecutando fetchPuntosLempirasCD con ID Cliente:", clienteId);
            const response = await fetch(`${server}/MgClientesPuntosCobroes/puntosCliente/${clienteId}`);
            if (response.ok) {
                const data = await response.json();
                console.log("Respuesta obtenida en fetchPuntosLempirasCD:", data);

                // Verificar si la respuesta contiene $values
                const clientePuntos = data?.$values?.[0];
                if (clientePuntos) {
                    setPuntosClienteD((clientePuntos.saldo).toFixed(2) || 0);
                    const lempiras = (clientePuntos.saldo * 0.030).toFixed(2);
                    setLempirasClienteD(lempiras || 0);
                } else {
                    console.error("No se encontraron datos en $values");
                    setPuntosClienteD(0);
                    setLempirasClienteD(0);
                }
            } else {
                console.error("Error en fetchPuntosLempirasCD: Respuesta no OK");
            }
        } catch (error) {
            console.error("Error en fetchPuntosLempirasCD:", error);
        }
    };

    const debouncedFetchClientes = useMemo(() => debounce(fetchClientes, 500), []);

    const handleInputChangeD = (event, newInputValue) => {
        setInputValueD(newInputValue);
        debouncedFetchClientes(newInputValue);
    };

    const handleInputChangeA = (event, newInputValue) => {
        setInputValueA(newInputValue);
        debouncedFetchClientes(newInputValue);
    };

    const handleBuscar = async () => {
        if (!fechaDesde || !fechaHasta) {
            Swal.fire('Error', 'Por favor, selecciona un rango de fechas válido.', 'error');
            return;
        }

        try {
            const body = {
                fechaDesde,
                fechaHasta,
                search,
            };
            console.log(body);
            const response = await fetch(
                `${server}/MgClientesPuntosTrasladoes/Paginados`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                }
            );

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                // Si la respuesta tiene una propiedad $values, la usamos; de lo contrario, asumimos que es un arreglo
                const traslados = data?.cotizaciones?.$values || [];
                console.log(traslados);
                setTrasladosPuntos(traslados);
            } else {
                Swal.fire('Error', 'No se pudieron obtener los datos.', 'error');
            }
        } catch (error) {
            console.error('Error al buscar datos:', error);
            Swal.fire('Error', 'Ocurrió un error al realizar la búsqueda.', 'error');
        }
    };


    const handleGuardar = async () => {
        if (!concepto || lempirasAcreditar <= 0) {
            Swal.fire('Error', 'Debe ingresar un concepto y un monto válido.', 'error');
            return;
        }

        if (tipoOperacion === 'Traslado' && (!clienteDebitar || !clienteAcreditar)) {
            Swal.fire('Error', 'Debes seleccionar ambos clientes para un traslado.', 'error');
            return;
        }

        if (tipoOperacion === 'Débito' && !clienteDebitar) {
            Swal.fire('Error', 'Selecciona un cliente a debitar.', 'error');
            return;
        }

        if (tipoOperacion === 'Acreditación' && !clienteAcreditar) {
            Swal.fire('Error', 'Selecciona un cliente a acreditar.', 'error');
            return;
        }

        if (clienteDebitar && lempirasAcreditar > lempirasClienteD) {
            Swal.fire('Error', 'No puedes debitar más lempiras de los disponibles.', 'error');
            return;
        }

        const traslado = {
            fecha: new Date().toISOString().split('T')[0],
            idClienteDebito: clienteDebitar?.idCliente ?? null,
            puntosAnterioresDebito: puntosClienteD,
            lempirasAnterioresDebito: lempirasClienteD,
            puntosActualesDebito: clienteDebitar
                ? (parseFloat(puntosClienteD) - (parseFloat(lempirasAcreditar) / 0.030))
                : 0,
            lempirasActualesDebito: clienteDebitar
                ? (parseFloat(lempirasClienteD) - parseFloat(lempirasAcreditar))
                : 0,
            idClienteCredito: clienteAcreditar?.idCliente ?? null,
            puntosAnterioresCredito: puntosClienteA,
            lempirasAnterioresCredito: lempirasClienteA,
            puntosActualesCredito: clienteAcreditar
                ? (parseFloat(puntosClienteA) + (parseFloat(lempirasAcreditar) / 0.030))
                : 0,
            lempirasActualesCredito: clienteAcreditar
                ? (parseFloat(lempirasClienteA) + parseFloat(lempirasAcreditar))
                : 0,
            lempiras: lempirasAcreditar,
            concepto,
            tipoOperacion,
            ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
        };

        try {
            const response = await fetch(`${server}/MgClientesPuntosTrasladoes`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(traslado),
            });

            if (!response.ok) {
                Swal.fire('Error', 'Ocurrió un error al guardar el traslado.', 'error');
                return;
            }

            const data = await response.json();
            const idTraslado = data.id;
            if (!idTraslado) {
                throw new Error('No se recibió el id en el resultado de data');
            }

            const numeroTraslado = `T${String(idTraslado).padStart(8, '0')}`;

            // Registrar movimiento si hay cliente acreditado
            if (clienteAcreditar) {
                const dataPuntosA = {
                    idCliente: clienteAcreditar.idCliente,
                    idTipo: 1, // Acreditación
                    idTipoAsignacion: 5,
                    puntos: (parseFloat(lempirasAcreditar) / 0.030),
                    documento: numeroTraslado,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
                };

                const resA = await fetch(`${server}/MgClientesPuntoes`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(dataPuntosA)
                });

                if (!resA.ok) {
                    throw new Error('Error al guardar el detalle de puntos del cliente acreditado');
                }
            }

            // Registrar movimiento si hay cliente debitado
            if (clienteDebitar) {
                const dataPuntosD = {
                    idCliente: clienteDebitar.idCliente,
                    idTipo: 2, // Débito
                    idTipoAsignacion: 6,
                    puntos: -(parseFloat(lempirasAcreditar) / 0.030),
                    documento: numeroTraslado,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
                };

                const resD = await fetch(`${server}/MgClientesPuntoes`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(dataPuntosD)
                });

                if (!resD.ok) {
                    throw new Error('Error al guardar el detalle de puntos del cliente debitado');
                }
            }

            Swal.fire('Éxito', 'El traslado fue registrado correctamente.', 'success');
        } catch (error) {
            console.error('Error al guardar el traslado:', error);
            Swal.fire('Error', 'Ocurrió un error inesperado.', 'error');
        }
    };


    const handleGuardar1 = async () => {
        if (!concepto || lempirasAcreditar <= 0) {
            Swal.fire('Error', 'Debe ingresar un concepto y un monto válido.', 'error');
            return;
        }

        if (tipoOperacion === 'Traslado' && (!clienteDebitar || !clienteAcreditar)) {
            Swal.fire('Error', 'Debes seleccionar ambos clientes para un traslado.', 'error');
            return;
        }

        if (tipoOperacion === 'Débito' && !clienteDebitar) {
            Swal.fire('Error', 'Selecciona un cliente a debitar.', 'error');
            return;
        }

        if (tipoOperacion === 'Acreditación' && !clienteAcreditar) {
            Swal.fire('Error', 'Selecciona un cliente a acreditar.', 'error');
            return;
        }

        if (clienteDebitar && lempirasAcreditar > lempirasClienteD) {
            Swal.fire('Error', 'No puedes debitar más lempiras de los disponibles.', 'error');
            return;
        }


        const traslado = {
            fecha: new Date().toISOString().split('T')[0],
            idClienteDebito: clienteDebitar?.idCliente ?? null,
            puntosAnterioresDebito: puntosClienteD,
            lempirasAnterioresDebito: lempirasClienteD,
            puntosActualesDebito: clienteDebitar
                ? (parseFloat(puntosClienteD) - (parseFloat(lempirasAcreditar) / 0.030))
                : 0,
            lempirasActualesDebito: clienteDebitar
                ? (parseFloat(lempirasClienteD) - parseFloat(lempirasAcreditar))
                : 0,
            idClienteCredito: clienteAcreditar?.idCliente ?? null,
            puntosAnterioresCredito: puntosClienteA,
            lempirasAnterioresCredito: lempirasClienteA,
            puntosActualesCredito: clienteAcreditar
                ? (parseFloat(puntosClienteA) + (parseFloat(lempirasAcreditar) / 0.030))
                : 0,
            lempirasActualesCredito: clienteAcreditar
                ? (parseFloat(lempirasClienteA) + parseFloat(lempirasAcreditar))
                : 0,
            lempiras: lempirasAcreditar,
            concepto,
            tipoOperacion, // Nuevo campo
            ingresadoPor: user ? user.codigoUsuario : 'ADMIN'
        };

        console.log(traslado);
        try {
            const response = await fetch(`${server}/MgClientesPuntosTrasladoes`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(traslado),
            });
            if (response.ok) {
                const data = await response.json();
                const idTraslado = data.id;
                if (!idTraslado) {
                    throw new Error('No se recibió el id en el resultado de data');
                }

                // Generar el número de traslado en formato T00000006
                const numeroTraslado = `T${String(idTraslado).padStart(8, '0')}`;
                console.log('Número de Traslado:', numeroTraslado);

                const dataPuntosCliente = {
                    idCliente: clienteAcreditar.idCliente,
                    idTipo: 1,
                    idTipoAsignacion: 5,
                    puntos: (parseFloat(puntosClienteD) - (parseFloat(lempirasAcreditar) / 0.030)),
                    documento: numeroTraslado,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN'

                }
                console.log(dataPuntosCliente);
                const responseDetallePuntosC = await fetch(`${server}/MgClientesPuntoes`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataPuntosCliente),
                });

                if (!responseDetallePuntosC.ok) {
                    throw new Error('Error al guardar el detalle de puntos de la factura');
                }
                const resultPuntosC = await responseDetallePuntosC.json();
                console.log(resultPuntosC.id);
                const idPuntoC = resultPuntosC?.id;
                if (!idPuntoC) {
                    throw new Error('No se recibió el id en el resultado de resultPuntosC');
                }


                Swal.fire('Éxito', 'El traslado fue registrado correctamente.', 'success');
            } else {
                Swal.fire('Error', 'Ocurrió un error al guardar el traslado.', 'error');
            }
        } catch (error) {
            console.error('Error al guardar el traslado:', error);
        }
    };
    return (
        <div className="right_col" role="main">
            <div className="x_content">

                {/* <div className="row"> */}
                {/* <div className="col-md-8 col-sm-7 offset-md-2"> */}
                <div style={{ padding: 20 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={3}>
                            <TextField
                                select
                                label="Tipo de Operación"
                                value={tipoOperacion}
                                onChange={(e) => setTipoOperacion(e.target.value)}
                                fullWidth
                                SelectProps={{ native: true }}
                            >
                                <option value="Traslado">Traslado</option>
                                <option value="Acreditación">Acreditación</option>
                                <option value="Débito">Débito</option>
                            </TextField>
                        </Grid>
                        {/* Sección de traslado */}
                        <Grid item xs={12}>
                            <h2>Traslado de Puntos</h2>
                        </Grid>
                        <Grid item xs={6}>

                            <Autocomplete
                                disabled={tipoOperacion === 'Acreditación'}
                                freeSolo
                                options={clientes}
                                value={clienteDebitar}
                                getOptionLabel={(option) => option?.nombreCompleto || ''}
                                isOptionEqualToValue={(option, value) => option?.idCliente === value?.idCliente}
                                inputValue={inputValueD}
                                onInputChange={handleInputChangeD}
                                onChange={(e, value) => {
                                    if (value?.idCliente === clienteAcreditar?.idCliente) {
                                        Swal.fire('Error', 'El cliente a debitar no puede ser el mismo que el cliente a acreditar.', 'error');
                                        setClienteDebitar(null); // Deseleccionar
                                    } else {
                                        setClienteDebitar(value);
                                        if (value?.idCliente) {
                                            fetchPuntosLempirasCD(value.idCliente);
                                        }
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Cliente a Debitar"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isLoading && <CircularProgress color="inherit" size={20} />}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Puntos"
                                value={puntosClienteD}
                                fullWidth
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Lempiras"
                                value={lempirasClienteD}
                                fullWidth
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        <Grid item xs={6}>

                            <Autocomplete
                                disabled={tipoOperacion === 'Débito'}
                                freeSolo
                                options={clientes}
                                value={clienteAcreditar}
                                getOptionLabel={(option) => option?.nombreCompleto || ''}
                                isOptionEqualToValue={(option, value) => option?.idCliente === value?.idCliente}
                                inputValue={inputValueA}
                                onInputChange={handleInputChangeA}
                                onChange={(e, value) => {
                                    if (value?.idCliente === clienteDebitar?.idCliente) {
                                        Swal.fire('Error', 'El cliente a acreditar no puede ser el mismo que el cliente a debitar.', 'error');
                                        setClienteAcreditar(null); // Deseleccionar
                                    } else {
                                        setClienteAcreditar(value);
                                        if (value?.idCliente) {
                                            fetchPuntosLempirasCA(value.idCliente);
                                        }
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Cliente a Acreditar"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {isLoading && <CircularProgress color="inherit" size={20} />}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />

                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Puntos"
                                value={puntosClienteA}
                                fullWidth
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Lempiras"
                                value={lempirasClienteA}
                                fullWidth
                                inputProps={{ readOnly: true }}
                            />
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                label="Concepto"
                                value={concepto}
                                onChange={(e) => setConcepto(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Lempiras"
                                value={lempirasAcreditar}
                                onChange={(e) => setLempirasAcreditar(e.target.value)}
                                fullWidth

                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" onClick={handleGuardar} disabled={!tienePermiso('Trasladar Puntos Cliente')}>
                                Guardar
                            </Button>
                        </Grid>

                        {/* Sección de tabla */}
                        <Grid item xs={12}>
                            <h2>Historial de Traslados</h2>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Buscar"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type="date"
                                label="Fecha Desde"
                                InputLabelProps={{ shrink: true }}
                                value={fechaDesde}
                                onChange={(e) => setFechaDesde(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                type="date"
                                label="Fecha Hasta"
                                InputLabelProps={{ shrink: true }}
                                value={fechaHasta}
                                onChange={(e) => setFechaHasta(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Button variant="contained" color="primary" onClick={handleBuscar} disabled={!tienePermiso('Buscar Traslado Puntos')}>
                                Buscar
                            </Button>
                        </Grid>

                        {/* Tabla */}
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Fecha</TableCell>
                                            <TableCell>N. Traslado</TableCell>
                                            <TableCell>Concepto</TableCell>
                                            <TableCell>Cliente Debitado</TableCell>
                                            <TableCell>Cliente Acreditado</TableCell>
                                            <TableCell>Valor Trasladado (L.)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {trasladosPuntos.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.fecha}</TableCell>
                                                <TableCell>{row.id}</TableCell>
                                                <TableCell>{row.concepto}</TableCell>
                                                <TableCell>{row.clienteDebito}</TableCell>
                                                <TableCell>{row.clienteCredito}</TableCell>
                                                <TableCell>{row.lempiras}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        <Grid item xs={12}>
                            <Button variant="contained" color="secondary" style={{ marginRight: 10 }} disabled={!tienePermiso('Imprimir Traslado Puntos')}>
                                Imprimir
                            </Button>
                            <Button variant="contained" color="error" disabled={!tienePermiso('Anular Traslado Puntos')}>
                                Anular
                            </Button>
                        </Grid>
                    </Grid>
                </div>
                {/* </div> */}
                {/* </div> */}
            </div>
        </div>
    );
};

export default TrasladoPuntos;
